module.exports = __webpack_public_path__ + "img/010088.a2680c4f.png";